"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const badges = [{
  name: "Google",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/trust_google.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/trust_google.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/trust_google.png-wvc-sizes",
  alt: "Google 5 Star Reviews"
}, {
  name: "Yelp",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/trust_yelp.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/trust_yelp.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/trust_yelp.png-wvc-sizes",
  alt: "Yelp Top Rated"
}, {
  name: "TripAdvisor",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/trust_tripadvisor.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/trust_tripadvisor.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/trust_tripadvisor.png-wvc-sizes",
  alt: "TripAdvisor Certificate of Excellence"
}, {
  name: "BBB",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/trust_bbb.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/trust_bbb.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/trust_bbb.png-wvc-sizes",
  alt: "Better Business Bureau A+ Rating"
}, {
  name: "NLA",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/trust_nla.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/trust_nla.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/trust_nla.png-wvc-sizes",
  alt: "National Limousine Association Member"
}];
export default function TrustBadges() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return;
}